import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-bearbeiten-berechtigung-entfernen-multi';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenDokumentBearbeitenBerechtigungEntfernenMultiEffects {

    DokumentBearbeitenBerechtigungEntfernenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_BEARBEITEN_BERECHTIGUNG_ENTFERNEN_MULTI),
        mergeMap((x: ac.PostDokumentBearbeitenBerechtigungEntfernenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentBearbeitenBerechtigungEntfernenMulti(x.dokumentBerechtigungMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentBearbeitenBerechtigungEntfernenMultiErfolgreichAction(result, x.dokumentBerechtigungMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentBearbeitenBerechtigungEntfernenMultiFehlerAction(error, x.dokumentBerechtigungMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumenteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumenteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumenteCommandService);
        }
        return this.service;
    }
}
